export default {
  header: 'Ups, algo inesperado aconteceu',
  text: 'Por favor, recarregue a página ou clique no botão «Voltar ao Menu» abaixo.',
  button: 'Voltar ao Menu',
};
